import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Row } from "react-bootstrap";
import { axiosAuth_DATA_MGMT_API, axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const LiftAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
  });

  const [wingList, setWingList] = useState([]);
  const [zoneList, setZoneList] = useState([]);

  const cabTypeOptions = [
    { key: "SINGLE_DECK", value: "SINGLE_DECK" },
    { key: "DOUBLE_DECK", value: "DOUBLE_DECK" }
  ];

  const statusOptions = [
    { key: "ACTIVE",      value: "ACTIVE" },
    { key: "DEACTIVATED", value: "DEACTIVATED" }
  ];


  // UI Functions

  const [errMsg, setErrMsg] = useState('');


  // Initialize state
  useEffect(() => {

    fetchLiftAdminConfigs();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const fetchLiftAdminConfigs = () => {

    return new Promise(async (resolve, reject) => {

      try {
        const res = await axiosAuth_PLATFORM_API.get("business-configs?name=LIFT_ADMIN");

        resolve(res.data);

        if (res.status === 200) {

          if ((res.data.length > 0) && res.data[0].config) {

            setWingList(res.data[0].config.wingList);
            setZoneList(res.data[0].config.zoneList);
          }
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

  const onDropdownSelect = (target, key) => {

    switch (target) {
      case 'cabType':
        setObjAttrs({ ...objAttrs, cabType: key })
        break;
      case 'wing':
        setObjAttrs({ ...objAttrs, wing: key })
        break;
      case 'zone':
        setObjAttrs({ ...objAttrs, zone: key })
        break;
      case 'status':
        setObjAttrs({ ...objAttrs, status: key })
        break;
      default:
        break;
    }
  };

  const handleCreateCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }

  const handleCreateSubmit = (e) => {
    e.preventDefault();

    // Validate form inputs
    if (!objAttrs.code || objAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_code"));
      return;
    } else if (objAttrs.code.length > 20) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 20);
      return;

    } else if (!objAttrs.name || objAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
      return;
    } else if (objAttrs.name.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 100);
      return;

    } else if (objAttrs.nameLang2 && (objAttrs.nameLang2 != null) && objAttrs.nameLang2.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ") - " + t("I18N_ERR_Max_len") + "100");
      return;

    } else if (objAttrs.nameLang3 && (objAttrs.nameLang3 != null) && objAttrs.nameLang3.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ") - " + t("I18N_ERR_Max_len") + "100");
      return;

    } else if (objAttrs.displayName && (objAttrs.displayName != null) && objAttrs.displayName.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_disp_name") + 30);
      return;

    } else if (objAttrs.description && (objAttrs.description != null) && objAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
      return;

    } else if (objAttrs.apiCode && (objAttrs.apiCode != null) && objAttrs.apiCode.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_api_code") + 100);
      return;

    }

    const reqBody = objAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("lifts", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }



  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Lift")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Lift_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>

            <Row className={classes.admin_pages__field_label}>
              <Col sm={3}>{t("I18N_Code")}: *</Col>
              <Col sm={3}>{t("I18N_Name")}: *</Col>
              <Col sm={3}>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}:</Col>
              <Col sm={3}>{t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ")"}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="code" value={objAttrs.code}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name" value={objAttrs.name}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="nameLang2" value={objAttrs.nameLang2}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="nameLang3" value={objAttrs.nameLang3}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col sm={3}>{t("I18N_Description")}:</Col>
              <Col sm={3}>{t("I18N_Display_name")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_label}>
              <Col sm={3}>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px', backgroundColor:'white'}}
                          name="description" value={objAttrs.description}
                          onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="displayName" value={objAttrs.displayName}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Cab_type")}:</Col>
              <Col>{t("I18N_Wing")}:</Col>
              <Col>{t("I18N_Zone")}:</Col>
              <Col>{t("I18N_API_code")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_label}>
              <Col sm={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={ !objAttrs.cabType ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_" + objAttrs.cabType) }
                  onSelect={(key) => onDropdownSelect('cabType', key)}>
                  {cabTypeOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col sm={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={ !objAttrs.wing ? t("common:I18N_DROPDOWN_PROMPT") : objAttrs.wing }
                  onSelect={(key) => onDropdownSelect('wing', key)}>
                  {wingList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item} className={classes.dropdown_item_wrap}>
                        {item}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col sm={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={ !objAttrs.zone ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_" + objAttrs.zone) }
                  onSelect={(key) => onDropdownSelect('zone', key)}>
                  {zoneList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="apiCode" value={objAttrs.apiCode}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col sm={3}>{t("I18N_Status")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col sm={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={ !objAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_" + objAttrs.status) }
                  onSelect={(key) => onDropdownSelect('status', key)}>
                  {statusOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.key)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
            </Row>

          </Container>
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
          <span>{t("I18N_Req_fields")}</span>
        </Row>

        <Row>
          <div display='flex' style={{ marginTop: '15px' }}>
            <Button size="sm" variant="outline-secondary" className="mb-3"
              style={{ float: 'left' }}
              onClick={handleCreateCancel}>
              {t("I18N_Cancel")}
            </Button>
            <Button size="sm" variant="outline-secondary" className="mb-3"
              style={{ marginLeft: '15px' }}
              onClick={handleCreateSubmit}>
              {t("I18N_Submit")}
            </Button>
            <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
              {errMsg}
            </span>
          </div>
        </Row>

      </Card>
    </>
  );
}

export default LiftAdminNewView;
